import { AccountAuditLogs } from '@/features/audit-logs/AccountAuditLogs';

export default function AuditLogsPage() {
  return <AccountAuditLogs />;
}
